<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      :label="label"
      item-text="name"
      item-value="id"
      return-object
      hide-details
  />
</template>

<script>

import VueTypes from "vue-types";

import {ItemBoostMode} from "@/modules/redactor/models/item/boost/ItemBoostMode";

export default {
  name: "r-item-boost-mode",
  props: {
    model: VueTypes.instanceOf(ItemBoostMode),
    label: VueTypes.string.def("Mode:"),
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return ItemBoostMode.getValues();
    }
  }
}
</script>